import React from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';
import { SxProps } from '@mui/material';

interface FormFieldProps {
  children: React.ReactNode;
  label?: string;
  error?: boolean;
  helperText?: string | string[] | undefined;
  fullWidth?: boolean;
  required?: boolean;
  disabled?: boolean;
  sx?: SxProps;
}

const FormField: React.FC<FormFieldProps> = ({
  children,
  label,
  error,
  helperText,
  fullWidth = true,
  required = false,
  disabled = false,
  sx,
}) => (
  <FormControl
    error={error}
    fullWidth={fullWidth}
    required={required}
    disabled={disabled}
    sx={{
      ...sx,
      height: '80px',
      position: 'relative',
    }}
  >
    {label && (
      <InputLabel
        style={{ marginLeft: '-13px', marginBottom: '-25px', fontSize: '17px' }}
        error={error}
      >
        {label}
      </InputLabel>
    )}
    {children}
    {helperText && (
      <FormHelperText 
        error={error}
        sx={{
          position: 'absolute',
          bottom: '-20px',
          left: 0,
          margin: 0,
          fontSize: '0.75rem',
        }}
      >
        {helperText}
      </FormHelperText>
    )}
  </FormControl>
);

export default FormField;
